<template>
  <div style="padding: 1vw">
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 0 1vw;
      "
    >
      <div class="pageTitle">
        <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
          리셀러 계정 관리
        </h3>
        <span class="pageDesc">
          리셀러 페이지에 접속한 계정을 조회하고 관리할 수 있습니다.
        </span>
      </div>
      <div style="display: flex; align-items: center">
        <button class="btn btn-primary" type="button" @click="downloadExcel()">
          엑셀 내려받기
        </button>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div class="searchdropbox" />
      <div class="searchinputbox">
        <select v-model="searchFilter" id="itemCode">
          <option value="" selected>선택</option>
          <option value="corpName">리셀러명</option>
          <option value="name">관리자명</option>
          <option value="username">관리자 아이디</option>
        </select>
        <input
          type="text"
          placeholder="조건을 입력해주세요."
          v-model="condition"
          ref="cdInput"
          id=""
          autocomplete="off"
          @keyup.enter="enter()"
          :readonly="!isFocused"
          @focus="isFocused = true"
        />
        <div class="searchBtn">
          <img
            src="../../assets/img/search.png"
            alt="search"
            class="hoverPointer"
            @click="enter()"
          />
        </div>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div />
      <div class="searchinputbox">
        <select
          class="search-select"
          v-model="rowsPerPage"
          @change="handleRowsPerPage"
        >
          <option :value="10">10개씩 보기</option>
          <option :value="20">20개씩 보기</option>
          <option :value="50">50개씩 보기</option>
          <option :value="100">100개씩 보기</option>
        </select>
      </div>
    </div>
    <div class="container-wrapper">
      <a-table
        class="ant-table-striped"
        size="small"
        v-if="responseData"
        :columns="columns"
        :data-source="responseData"
        :pagination="false"
        @resizeColumn="handleResizeColumn"
        @change="handleTableChange"
      >
        <template #emptyText>
          <div class="noResult">검색 결과가 없습니다.</div>
        </template>
      </a-table>
      <pagination
        :page-info="paginationData"
        page-name="ResellerAccManage"
        @change-page="paginationHandler"
      />
    </div>
    <!-- 연결해제 모달 -->
    <div
      class="modal fade"
      id="logoutyesno"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="justify-content: center !important"
      >
        <div
          class="modal-content"
          style="width: 70% !important; padding-top: 0.5vw"
        >
          <div class="modal-body" style="display: flex; flex-direction: column">
            <div style="text-align: center; padding-top: 1rem">
              <h4>계정 연결 해제</h4>
              <h6>해당 계정을 로그아웃 처리하시겠습니까?</h6>
            </div>
            <div
              style="display: flex; justify-content: center; margin-top: 2rem"
            >
              <button
                style="margin-right: 1vw"
                type="button"
                class="btn btn-primary"
                @click="logoutUser()"
              >
                연결 해제
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                취소
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 초기화 모달 -->
    <div
      class="modal fade"
      id="resetyesno"
      tabindex="-1"
      aria-labelledby="resetModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="justify-content: center !important"
      >
        <div
          class="modal-content"
          style="width: 70% !important; padding-top: 0.5vw"
        >
          <div class="modal-body" style="display: flex; flex-direction: column">
            <div style="text-align: center; padding-top: 1rem">
              <h4>비밀번호 초기화</h4>
              <h6>임시 비밀번호는 관리자 ID와 동일합니다.</h6>
              <h6>초기화하시겠습니까?</h6>
            </div>
            <div
              style="display: flex; justify-content: center; margin-top: 2rem"
            >
              <button
                style="margin-right: 1vw"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                취소
              </button>
              <button
                type="button"
                class="btn btn-warning"
                data-bs-dismiss="modal"
                @click="resetPassword()"
              >
                초기화
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 관리자 계정 수정 모달 -->
    <a-modal
      v-model:visible="editModalVisible"
      :confirm-loading="editLoading"
      :footer="null"
      @cancel="cancelEdit"
    >
      <template #title>
        <div class="modal-title">관리자 계정 수정</div>
      </template>

      <div class="modal-content">
        <a-form layout="vertical" :model="formEdit" ref="editForm">
          <a-form-item
            label="새 관리자 ID"
            name="username"
            :rules="[
              { required: true, message: '새로운 관리자 ID를 입력하세요' },
            ]"
          >
            <a-input
              v-model:value="formEdit.username"
              placeholder="새로운 관리자 ID를 입력하세요"
              @change="handleUsernameChange"
            />
          </a-form-item>

          <a-divider />

          <!-- 비밀번호 변경 섹션 -->
          <div class="password-section">
            <h4 style="margin-bottom: 16px; font-size: 14px; font-weight: 600">
              비밀번호 변경
            </h4>

            <a-form-item label="새 비밀번호" name="newPassword">
              <a-input-password
                v-model:value="formEdit.newPassword"
                placeholder="새 비밀번호를 입력하세요 (선택사항)"
                @change="handlePasswordChange"
              />
              <div v-if="formEdit.newPassword" class="password-hint">
                <small style="color: #666">
                  * 8자 이상 입력하세요<br />
                  * 영문, 숫자, 특수문자를 포함하세요
                </small>
              </div>
            </a-form-item>

            <a-form-item
              v-if="formEdit.newPassword"
              label="비밀번호 확인"
              name="confirmPassword"
            >
              <a-input-password
                v-model:value="formEdit.confirmPassword"
                placeholder="비밀번호를 다시 입력하세요"
                @change="handlePasswordChange"
              />
              <div
                v-if="
                  formEdit.confirmPassword &&
                  formEdit.newPassword !== formEdit.confirmPassword
                "
                class="password-error"
              >
                <small style="color: #ff4d4f"
                  >비밀번호가 일치하지 않습니다</small
                >
              </div>
            </a-form-item>
          </div>
        </a-form>

        <div class="modal-footer">
          <a-button @click="cancelEdit">취소</a-button>
          <a-button
            type="primary"
            @click="confirmEdit"
            :loading="editLoading"
            :disabled="!isFormValid"
            class="yellow-button"
            >확인</a-button
          >
        </div>
      </div>
    </a-modal>

    <!-- 2차 인증 창(상태·예외·잠금·초기화·이력, REQ-ACC-012) -->
    <account-security-modal
      :account="securityAccount"
      @close="securityAccount = null"
    />
  </div>
</template>
<script>
import { convertDate, openDialog, convertDateTime } from "@/utils/utils";
import Pagination from "@/views/components/Pagination.vue";
import AccountSecurityModal from "@/views/components/AccountSecurityModal.vue";
import dayjs from "dayjs";
import { isSupportRow, supportBadge } from "@/utils/accountRows";

export default {
  name: "resellerAccManage",
  components: {
    Pagination,
    AccountSecurityModal,
  },
  data() {
    return {
      convertDateTime,
      type: "RESELLER",
      securityAccount: null, // 「2차 인증」 창을 연 행

      // 목록 받아오는 변수
      responseData: [],

      // 페이지네이션 관련 변수
      listSize: 0,
      rowsPerPage: 10,
      page: 1,
      totalPages: 0,
      pageSize: 0,
      paginationPageAmount: 10,
      paginationList: [],
      isFirstPage: true,
      isFirstBlock: true,
      isLastBlock: false,
      isLastPage: false,

      selectedReseller: {},
      isFocused: false,

      searchFilter: "corpName",
      condition: "",
      sort: {
        parameter: "lastLoginAt",
        method: "DESC",
      },

      paginationData: {
        currentPage: 1,
        totalPages: 0,
      },
      columns: [
        {
          key: "corpName",
          title: "리셀러명",
          dataIndex: "corpName",
          align: "center",
        },
        { key: "name", title: "관리자명", dataIndex: "name", align: "center" },
        {
          key: "username",
          title: "관리자 ID",
          dataIndex: "username",
          align: "center",
        },
        { key: "ip", title: "IP", dataIndex: "ip", align: "center" },
        {
          key: "agent",
          title: "접속 기기",
          dataIndex: "agent",
          align: "center",
        },
        {
          key: "lastLoginAt",
          title: "최근 접속 시간",
          dataIndex: "lastLoginAt",
          align: "center",
          sorter: (a, b) =>
            dayjs(a.lastLoginAt || 0).unix() - dayjs(b.lastLoginAt || 0).unix(),
          customRender: ({ record }) => {
            return record.lastLoginAt
              ? this.convertDateTime(record.lastLoginAt)
              : "-";
          },
        },
        {
          key: "firstLoginAt",
          title: "최초 접속 시간",
          dataIndex: "firstLoginAt",
          align: "center",
          sorter: (a, b) =>
            dayjs(a.firstLoginAt || 0).unix() -
            dayjs(b.firstLoginAt || 0).unix(),
          customRender: ({ record }) => {
            return record.firstLoginAt
              ? this.convertDateTime(record.firstLoginAt)
              : "-";
          },
        },
        {
          key: "manage",
          title: "관리",
          dataIndex: "manage",
          align: "center",
          // 지원 서브 계정 행(support 칸)은 배지만 — 수정·초기화·2차 인증 버튼 없음(서버도 403, W6 A6)
          customRender: ({ record }) => isSupportRow(record) ? (
            <span class="support-badge">{supportBadge(record)}</span>
          ) : (
            <div style="display: flex; gap: 8px; justify-content: center;">
              {supportBadge(record) ? <span class="support-badge">{supportBadge(record)}</span> : null}
              <div
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#resetyesno"
                class="certi-custom-btn"
                onClick={() => {
                  this.selectReseller(record);
                }}
              >
                비밀번호 초기화
              </div>
              <div
                type="button"
                class="certi-custom-btn"
                style="white-space: nowrap"
                onClick={() => {
                  this.securityAccount = record;
                }}
              >
                2차 인증
              </div>
              <div
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#logoutyesno"
                class="certi-custom-btn"
                onClick={() => {
                  this.selectReseller(record);
                }}
              >
                연결해제
              </div>
              <div
                type="button"
                class="certi-custom-btn"
                onClick={() => {
                  this.editReseller(record);
                }}
              >
                수정
              </div>
            </div>
          ),
        },
      ],
      formEdit: {
        username: "",
        newPassword: "",
        confirmPassword: "",
      },
      editedRecord: {},
      editModalVisible: false,
      editLoading: false,
    };
  },

  async mounted() {
    const obj = {};
    obj.page = this.paginationData.currentPage;
    await this.paginationHandler(obj);
  },
  computed: {
    isFormValid() {
      const hasValidUsername =
        this.formEdit.username && this.formEdit.username.trim() !== "";

      if (this.formEdit.newPassword) {
        const isPasswordValid = this.validatePassword(
          this.formEdit.newPassword
        );
        const doPasswordsMatch =
          this.formEdit.newPassword === this.formEdit.confirmPassword;
        return hasValidUsername && isPasswordValid && doPasswordsMatch;
      }

      return hasValidUsername;
    },
  },
  methods: {
    validatePassword(password) {
      if (!password) return false;

      if (password.length < 8) return false;

      if (!/[a-zA-Z]/.test(password)) return false;

      if (!/[0-9]/.test(password)) return false;

      if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) return false;

      return true;
    },
    handlePasswordChange() {
      this.$forceUpdate();
    },
    async handleTableChange(pagination, filters, sorter, extra) {
      if (extra.action == "sort" && sorter.order) {
        this.sort = {
          parameter: sorter.field,
          method:
            sorter.order == "ascend"
              ? "ASC"
              : sorter.order == "descend"
              ? "DESC"
              : "",
        };
      } else if (extra.action == "sort" && !sorter.order) {
        this.sort = {
          parameter: "lastLoginAt",
          method: "DESC",
        };
      }
      const obj = {};
      obj.page = this.paginationData.currentPage;
      this.paginationHandler(obj);
    },
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getResellerAccountList();
    },
    async enter() {
      this.paginationData.currentPage = 1;
      await this.getResellerAccountList();
    },

    handleResizeColumn(w, col) {
      col.width = w;
    },

    // 전체 목록 가져오기
    async getResellerAccountList() {
      const obj = {};
      obj.page = this.paginationData.currentPage;
      obj.limit = this.rowsPerPage;
      obj.type = this.type;
      if (this.searchFilter) obj.search = this.searchFilter;
      if (this.condition) obj.condition = this.condition;
      if (this.sort) obj.sort = this.sort;

      try {
        const response = await this.$apiInstance.post(`/accounts/list`, obj);
        if (response.status === 200 || response.status === 201) {
          this.responseData = response.data.docs;
          this.listSize = response.data.totalDocs;
          this.paginationData.totalPages = response.data.totalPages;
          for (let i = 0; i < this.responseData.length; i++) {
            this.responseData[i].index =
              this.listSize -
              i -
              (this.paginationData.currentPage - 1) * this.rowsPerPage;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getResellerAccountList();
    },
    // 계정 연결해제
    async logoutUser() {
      try {
        const obj = {};
        obj.companyId = this.selectedReseller.companyId;
        obj.username = this.selectedReseller.username;

        const response = await this.$apiInstance.post(
          `/accounts/target/logout`,
          obj
        );
        if (response.status === 200 || response.status === 201) {
          await openDialog(
            "해당 계정이 로그아웃 처리되었습니다.",
            "success",
            "확인"
          ).then(() => {
            location.reload();
          });
        } else {
          await openDialog("로그아웃에 실패하였습니다.", "error", "확인");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async resetPassword() {
      try {
        const response = await this.$apiInstance.put(
          `/companies/resetPassword/${this.selectedReseller._id}`
        );
        if (response.status === 200 || response.status === 201) {
          await openDialog(
            "비밀번호가 초기화되었습니다.",
            "success",
            "확인"
          ).then(() => {
            location.reload();
          });
        }
      } catch (error) {
        console.log(error);
        await openDialog("비밀번호가 초기화에 실패했습니다.", "error", "확인");
      }
    },
    // 엑셀 다운로드
    async downloadExcel() {
      const year = new Date().getFullYear();
      const month = String(new Date().getMonth() + 1).padStart(2, "0");
      const day = String(new Date().getDate()).padStart(2, "0");

      const formattedDate = `${year}${month}${day}`;
      try {
        const response = await this.$apiInstance.get(
          `/accounts/excels/${this.type}`,
          {
            headers: {
              "Content-Type": "octet-stream",
            },
            responseType: "blob",
          }
        );

        if (response.status === 200 || response.status === 201) {
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });

          const url = URL.createObjectURL(blob);

          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.download = `리셀러계정_${formattedDate}.xlsx`;
          downloadLink.click();

          URL.revokeObjectURL(url);
        } else {
          // Handle the error case
        }
      } catch (error) {
        console.error("Error downloading Excel file:", error);
      }
    },

    // 날짜, 시간 포맷에 맞추기
    convertDate,

    // 보기, 수정, 삭제 시 선택
    selectReseller(reseller) {
      this.selectedReseller = reseller;
    },

    editReseller(record) {
      console.log("수정할 리셀러 계정:", record);
      this.editedRecord = record;
      this.formEdit.username = record.username;
      this.formEdit.newPassword = "";
      this.formEdit.confirmPassword = "";
      this.editModalVisible = true;
    },
    async confirmEdit() {
      if (!this.isFormValid) {
        return;
      }

      this.editLoading = true;

      try {
        const requestBody = {
          newUsername: this.formEdit.username,
        };

        if (
          this.formEdit.newPassword &&
          this.formEdit.newPassword.trim() !== ""
        ) {
          requestBody.newPassword = this.formEdit.newPassword;
        }

        const hasUsernameChange =
          this.formEdit.username !== this.editedRecord.username;
        const hasPasswordChange =
          this.formEdit.newPassword && this.formEdit.newPassword.trim() !== "";

        if (!hasUsernameChange && !hasPasswordChange) {
          this.editLoading = false;
          await openDialog("변경사항이 없습니다.", "warning", "확인");
          return;
        }

        await this.$apiInstance.put(
          `/accounts/username/${this.editedRecord._id}`,
          requestBody
        );

        this.editLoading = false;
        this.editModalVisible = false;

        let message = "수정이 완료되었습니다.";
        if (hasUsernameChange && hasPasswordChange) {
          message = "관리자 ID와 비밀번호가 변경되었습니다.";
        } else if (hasUsernameChange) {
          message = "관리자 ID가 변경되었습니다.";
        } else if (hasPasswordChange) {
          message = "비밀번호가 변경되었습니다.";
        }

        await openDialog(message, "success", "확인");
        location.reload();
      } catch (error) {
        this.editLoading = false;
        console.error(error);
        await openDialog("수정에 실패했습니다.", "error", "확인");
      }
    },
    cancelEdit() {
      this.editModalVisible = false;
      this.formEdit.username = "";
      this.formEdit.newPassword = "";
      this.formEdit.confirmPassword = "";
    },
    handleUsernameChange() {
      if (this.formEdit.username && this.formEdit.username.trim() !== "") {
        this.$refs.editForm.clearValidate("username");
      }
    },
  },
};
</script>
<style scoped>
/* 지원 서브 계정 행 배지(W6 A6) */
.support-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f0f2f5;
  color: #5c6168;
  font-size: 12px;
  white-space: nowrap;
}
.modal-title {
  font-size: 16px;
  font-weight: bold;
}

.modal-content {
  padding: 20px;
  border: none;
  background: #fff;

  :deep(.ant-form-item) {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
}

.password-section {
  margin-top: 8px;
}

.password-hint {
  margin-top: 8px;
}

.password-error {
  margin-top: 4px;
}

:deep(.ant-modal) {
  padding-bottom: 0;

  .ant-modal-content {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    .ant-modal-close {
      color: rgba(0, 0, 0, 0.45);
    }

    .ant-modal-header {
      padding: 16px 20px;
      border: none;
      background: #fff;
      margin: 0;
    }

    .ant-modal-body {
      padding: 0;
      background: #fff;
      border: none;
    }

    .ant-modal-header,
    .ant-modal-body,
    .ant-modal-footer {
      border: none;
    }
  }
}
</style>
